import { useState } from 'react';

import UploadDocument, { FilesCallback } from 'components/UploadDocument';
import { CardUploadWrapper, CardUploadTitle } from './styles';

interface ICardUpload {
  title: string;
  idDoc: string;
  required?: boolean;
  setState?: any;
  callbackFunc: (files: FilesCallback[]) => void;
  deleteFile: any;
  acceptedFiles?: string[];
  hasLoadingFiles?: boolean;
}

const CardDocument = ({
  title,
  idDoc,
  required = false,
  setState,
  callbackFunc,
  deleteFile,
  acceptedFiles,
  hasLoadingFiles,
}: ICardUpload): JSX.Element => {
  const [dropFiles, setDropFiles] = useState([]);

  const preventEvent = (e: any) => {
    e.preventDefault();
  };

  const fileDrop = (e: any) => {
    e.preventDefault();
    const { files: dropedFiles } = e.dataTransfer;
    if (dropedFiles?.length) {
      setDropFiles(dropedFiles);
    }
  };

  const handleCallbackFunction = (callbackFiles: FilesCallback[]) => {
    callbackFunc(callbackFiles);
    setDropFiles([]);
  };

  return (
    <CardUploadWrapper
      onDragOver={preventEvent}
      onDragEnter={preventEvent}
      onDragLeave={preventEvent}
      onDrop={fileDrop}
    >
      <CardUploadTitle>
        {title}
        {required && <span>*</span>}
      </CardUploadTitle>

      <UploadDocument
        key={idDoc}
        idDoc={idDoc}
        setState={setState}
        required={required}
        dropFiles={dropFiles}
        acceptedFiles={acceptedFiles}
        callbackFunc={handleCallbackFunction}
        deleteFile={deleteFile}
        hasLoadingFiles={hasLoadingFiles}
      />
    </CardUploadWrapper>
  );
};

export default CardDocument;
